import { ReactElement } from 'react';

import { ThemeProvider, useTheme } from 'styled-components';
import { ThemeModes, ThemeMode, themes, BaseProvider } from '@sede-x/shell-ds-react-base';

import { GlobalStyles } from '../../styles/GlobalStyles';

export interface IThemeProviderProps {
  theme: ThemeMode;
  children?: React.ReactNode;
}

export const ShellThemeProvider = ({
  theme: themeName = ThemeModes.light,
  children,
}: IThemeProviderProps): ReactElement => {
  const theme = themes[themeName];

  return (
    <BaseProvider useTheme={useTheme}>
      <ThemeProvider theme={{ ...theme, name: themeName }}>
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </BaseProvider>
  );
};
